import React from 'react';
import { theme } from '../../styles/theme';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'neutral';
  size?: 'sm' | 'md';
  style?: React.CSSProperties;
}

/** Small colored label for status indicators and tags. */
export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'primary',
  size = 'sm',
  style,
}) => {
  const variantStyles: Record<string, React.CSSProperties> = {
    primary: {
      background: `rgba(255, 77, 0, 0.15)`,
      color: theme.colors.primary,
      border: `1px solid rgba(255, 77, 0, 0.3)`,
    },
    secondary: {
      background: `rgba(0, 212, 255, 0.15)`,
      color: theme.colors.secondary,
      border: `1px solid rgba(0, 212, 255, 0.3)`,
    },
    success: {
      background: `rgba(0, 255, 136, 0.15)`,
      color: theme.colors.success,
      border: `1px solid rgba(0, 255, 136, 0.3)`,
    },
    error: {
      background: `rgba(255, 51, 102, 0.15)`,
      color: theme.colors.error,
      border: `1px solid rgba(255, 51, 102, 0.3)`,
    },
    warning: {
      background: `rgba(255, 184, 0, 0.15)`,
      color: theme.colors.warning,
      border: `1px solid rgba(255, 184, 0, 0.3)`,
    },
    neutral: {
      background: theme.colors.bgTertiary,
      color: theme.colors.textSecondary,
      border: `1px solid ${theme.colors.border}`,
    },
  };

  const sizeStyles: Record<string, React.CSSProperties> = {
    sm: {
      padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
      fontSize: theme.fontSizes.xs,
    },
    md: {
      padding: `${theme.spacing.xs} ${theme.spacing.md}`,
      fontSize: theme.fontSizes.sm,
    },
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: theme.borderRadius.full,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        ...variantStyles[variant],
        ...sizeStyles[size],
        ...style,
      }}
    >
      {children}
    </span>
  );
};

export default Badge;
